import {
  Button,
  Checkbox,
  CircularProgress,
  Dialog,
  DialogContent,
  DialogTitle,
  FormControlLabel,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableRow,
} from "@mui/material";
import { useCallback, useEffect, useState } from "react";
import { useQuery } from "@tanstack/react-query";
import { getGroups } from "../../../../services/InventoryAPI";

const ModalLabelFilter = ({ open, setOpen, listId, setListId, setType }) => {
  const [tempArr, setTempArr] = useState([]);

  const { data: labels, isFetching } = useQuery({
    queryKey: ["label"],
    queryFn: () => getGroups(),
  });

  const handleSelectList = useCallback(
    (selectedId) => {
      var temp = [...tempArr];
      const index = temp.findIndex((id) => id === selectedId);
      setTempArr(
        index < 0
          ? [...tempArr, selectedId]
          : [...tempArr.slice(0, index), ...tempArr.slice(index + 1)]
      );
    },
    [tempArr]
  );

  useEffect(() => {
    if (open) setTempArr(listId);
  }, [open]);

  return (
    <Dialog
      open={open}
      onClose={() => {
        setOpen(false);
      }}
    >
      <DialogTitle
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        Golongan
        {tempArr.length > 0 ? (
          <Button
            variant="contained"
            sx={{ marginLeft: 1 }}
            onClick={() => {
              setOpen(false);
              setListId(tempArr);
              setType("label");
            }}
          >
            Cari
          </Button>
        ) : null}
      </DialogTitle>
      <DialogContent>
        <TableContainer>
          <Table sx={{ width: "100%" }} aria-label="simple table">
            <TableBody>
              {labels && labels !== undefined && !isFetching ? (
                <>
                  {labels.map((label) => (
                    <TableRow
                      key={label.id}
                      sx={{
                        "&:last-child td, &:last-child th": { border: 0 },
                      }}
                    >
                      <TableCell
                        component="th"
                        scope="label"
                        sx={{ paddingY: 0 }}
                      >
                        <FormControlLabel
                          sx={{ width: "100%" }}
                          control={
                            <Checkbox
                              checked={tempArr.includes(label.id)}
                              onChange={() => {
                                handleSelectList(label.id);
                              }}
                            />
                          }
                          label={label.name}
                        />
                      </TableCell>
                    </TableRow>
                  ))}
                </>
              ) : isFetching ? (
                <CircularProgress size={20} />
              ) : (
                "Tidak ada golongan"
              )}
            </TableBody>
          </Table>
        </TableContainer>
      </DialogContent>
    </Dialog>
  );
};

export default ModalLabelFilter;
